import * as services from './account.queries';

export default services;
